import React from "react";

import { Tag } from "antd";

import { Link } from "react-router-dom";

import { LAYOUT_MANAGER_QUOTE_NEW, LAYOUT_MANAGER_QUOTE_SHOW } from "../../navigation";

import { displayId } from "../../../../components/quote";
import { QuoteStatusLabel } from "../../../../components/quote/status";
import DateTimeJob from "../../../../components/job/status/datetime"; /*TODO:QUOTE*/

import { basicDeleteActionField } from "../../../../components/table/fields/common";

import { configureSort, configureField } from "../../../../core/utils/list";

const confirmationMessage = "Are you sure?";

export const basicColumns = (props) => {
    const { toggle, loading, filters, resize, hidden, projectsById, pointsOfSaleById } = props;

    if (loading) {
        return [];
    }

    return [
        {
            title: "ID #",
            dataIndex: "id",
            key: "id",
            fixed: "left",
            width: 140,
            // eslint-disable-next-line react/display-name
            render: (eid, record) => <Link to={LAYOUT_MANAGER_QUOTE_SHOW(record.id)}>{displayId(record.id)}</Link>,
            ...configureField("q.id", filters, resize, hidden, true, false, false, 140),
        },
        /*
        {
            title: "E-ID #",
            dataIndex: "externalId",
            key: "externalId",
            fixed: "left",
            width: 140,
            // eslint-disable-next-line react/display-name
            ...configureField("q.externalId", filters, resize, hidden, true, false, false, 140),
        },*/
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            ellipsis: true,
            width: 140,
            ...configureField("q.status", filters, resize, hidden, true, false, true, 140),
            // eslint-disable-next-line react/display-name
            render: (text) => <QuoteStatusLabel status={text} />,
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            width: 300,
            ellipsis: true,
            ...configureField("q.name", filters, resize, hidden, true, false, true, 300),
            // eslint-disable-next-line react/display-name
            render: (name, record) => <>{name}</>,
        },
        {
            title: "Code",
            dataIndex: "receivableCode",
            key: "receivableCode",
            ...configureField("q.receivableCode", filters, resize, hidden, true, false, true, 200),
            // eslint-disable-next-line react/display-name
            render: (project) => {
                if (project) {
                    return <>{project} </>;
                }
            },
        },
        {
            title: "Project",
            dataIndex: "project",
            key: "projects",
            ...configureField("p.name", filters, resize, hidden, true, false, true, 200),
            // eslint-disable-next-line react/display-name
            render: (project) => {
                if (project && projectsById) {
                    return <>{projectsById[project]?.name}</>;
                }
            },
            //filters: props.projects
        },
        {
            title: "POS",
            dataIndex: "pointOfSale",
            key: "pointOfSale",
            ...configureField("pos.name", filters, resize, hidden, true, false, true, 200),
            // eslint-disable-next-line react/display-name
            render: (pointOfSale) => {
                if (pointOfSale && pointsOfSaleById) {
                    return <>{pointsOfSaleById[pointOfSale]?.name}</>;
                }
            },
            //filters: props.pointsOfSale,
        },
        {
            title: "FINAL DDL",
            dataIndex: "clientDeadlineAt",
            key: "clientDeadlineAt",
            ...configureField("q.clientDeadlineAt", filters, resize, hidden, true, false, true, 130),
            width: 130,
            // eslint-disable-next-line react/display-name
            render: (clientDeadlineAt, record) => <DateTimeJob value={clientDeadlineAt} status={record.status} />,
        },
    ];
};
